<app-dashboard-layout [loading]="reserving">
  <app-notification-alert [data]="notification"></app-notification-alert>

  <section *ngIf="refreshing">
    <div class="border rounded-md bg-gray-300 h-16 my-8 animate-pulse"></div>
    <div class="border rounded-md mx-auto max-w-md bg-gray-300 h-8 my-8 animate-pulse"></div>
  </section>

  <section *ngIf="!refreshing && info" class="max-w-2xl mx-auto py-6">
    <h2 class="text-xl font-bold mb-1">Admission Slot Reservation</h2>
    <p class="text-sm text-gray-500 mb-6">
      {{ info.ProgrammeName }} &middot; Level {{ info.Level }} &middot; {{ info.Session }} session
    </p>

    <!-- Not enabled -->
    <div *ngIf="!info.Enabled" class="rounded-md border border-yellow-300 bg-yellow-50 p-4 text-sm text-yellow-800">
      Slot reservation is not currently open for your programme, level and session.
    </div>

    <div *ngIf="info.Enabled">
      <!-- Slot availability -->
      <div class="grid grid-cols-2 gap-4 mb-6">
        <div class="rounded-md border p-4 text-center">
          <div class="text-3xl font-bold text-blue-600">{{ info.AvailableSlots }}</div>
          <div class="text-xs text-gray-500">slots available</div>
        </div>
        <div class="rounded-md border p-4 text-center">
          <div class="text-3xl font-bold">{{ info.NumberOfSlots }}</div>
          <div class="text-xs text-gray-500">total slots</div>
        </div>
      </div>

      <div *ngIf="info.InstructionsHTML" class="prose text-sm mb-6" [innerHTML]="info.InstructionsHTML"></div>

      <!-- No active reservation: allow reserving -->
      <div *ngIf="!info.HasReservation">
        <div class="rounded-md border bg-gray-50 p-4 text-sm mb-4">
          Reserve your slot to secure your place. You will have
          <strong>{{ info.ReservationHours }} hour(s)</strong> to pay the minimum required for registration.
          If you do not pay in time, your slot is released for another student.
        </div>
        <button
          (click)="reserveSlot()"
          [disabled]="info.AvailableSlots <= 0 || reserving"
          class="w-full rounded-md bg-blue-600 py-3 text-white font-semibold disabled:opacity-50"
        >
          {{ info.AvailableSlots > 0 ? "Reserve My Slot" : "No slots available" }}
        </button>
      </div>

      <!-- Pending reservation: awaiting payment -->
      <div *ngIf="info.HasReservation && info.Status === 'Pending'">
        <div class="rounded-md border border-blue-300 bg-blue-50 p-4 text-sm mb-4">
          <p class="font-semibold text-blue-800 mb-1">Slot reserved &mdash; awaiting payment</p>
          <p>Reserved: {{ info.ReservationStartTime | date: "medium" }}</p>
          <p>Expires: {{ info.ReservationEndTime | date: "medium" }}</p>
          <p class="mt-2 text-lg font-bold text-red-600">Time left: {{ countdown }}</p>
        </div>
        <button (click)="goToPayments()" class="w-full rounded-md bg-green-600 py-3 text-white font-semibold">
          Pay Minimum Registration Fee
        </button>
      </div>

      <!-- Confirmed -->
      <div
        *ngIf="info.HasReservation && info.Status === 'Confirmed'"
        class="rounded-md border border-green-300 bg-green-50 p-4 text-sm text-green-800"
      >
        <p class="font-semibold mb-1">Your slot is confirmed 🎉</p>
        <p>You have paid the minimum required for registration and your slot is secured.</p>
      </div>
    </div>
  </section>
</app-dashboard-layout>
